export default __webpack_public_path__ + "static/media/test-drive-banner-eng.fd0f69ee.jpg";